/* ABERA site helpers: scroll reveal, copy link, campaign countdown. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-ab-reveal]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    doc.classList.add('ab-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ab-copy');
    if (!b) return;
    var url = b.getAttribute('data-copy');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1600);
      });
    }
  });

  if (!customElements.get('abera-countdown')) {
    customElements.define('abera-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = parseInt(this.dataset.end, 10) * 1000;
        this.d = this.querySelector('[data-d]'); this.h = this.querySelector('[data-h]');
        this.m = this.querySelector('[data-m]'); this.s = this.querySelector('[data-s]');
        this.tick(); this.t = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
      tick() {
        var left = Math.max(0, this.end - Date.now());
        if (!left) { clearInterval(this.t); this.hidden = true; return; }
        var s = Math.floor(left / 1000);
        var p = function (n) { return n < 10 ? '0' + n : '' + n; };
        this.d.textContent = Math.floor(s / 86400);
        this.h.textContent = p(Math.floor(s % 86400 / 3600));
        this.m.textContent = p(Math.floor(s % 3600 / 60));
        this.s.textContent = p(s % 60);
      }
    });
  }


  /* Banner: gentle pointer + scroll drift, hotspots */
  function initBanner() {
    document.querySelectorAll('[data-ab-parallax]').forEach(function (bn) {
      var media = bn.querySelector('.ab-bn__media picture, .ab-bn__tiles');
      if (!media || reduce) return;
      var tx = 0, ty = 0, sy = 0, raf = 0;
      function paint() { raf = 0; media.style.transform = 'translate3d(' + tx + 'px,' + (ty + sy) + 'px,0) scale(1.04)'; }
      function queue() { if (!raf) raf = requestAnimationFrame(paint); }
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        bn.addEventListener('pointermove', function (e) {
          var r = bn.getBoundingClientRect();
          tx = ((e.clientX - r.left) / r.width - 0.5) * -14;
          ty = ((e.clientY - r.top) / r.height - 0.5) * -10;
          queue();
        });
        bn.addEventListener('pointerleave', function () { tx = 0; ty = 0; queue(); });
      }
      window.addEventListener('scroll', function () {
        var r = bn.getBoundingClientRect();
        if (r.bottom < 0) return;
        sy = Math.max(0, -r.top) * 0.08; queue();
      }, { passive: true });
      paint();
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ab-hspot__dot');
    document.querySelectorAll('.ab-hspot.is-open').forEach(function (s) {
      if (!dot || s !== dot.parentNode) { s.classList.remove('is-open'); s.querySelector('.ab-hspot__dot').setAttribute('aria-expanded', 'false'); }
    });
    if (dot) { var on = dot.parentNode.classList.toggle('is-open'); dot.setAttribute('aria-expanded', on); }
  });

  /* UGC videos: load on demand, muted preview on hover, sound on click */
  if (!customElements.get('abera-ugc')) {
    customElements.define('abera-ugc', class extends HTMLElement {
      connectedCallback() {
        this.v = this.querySelector('video'); this.b = this.querySelector('.ab-ugc__play');
        var self = this;
        this.load = function () { if (!self.v.src) self.v.src = self.v.dataset.src; };
        if (window.matchMedia('(hover: hover)').matches && !reduce) {
          this.addEventListener('mouseenter', function () { if (self.classList.contains('is-sound')) return; self.load(); self.v.muted = true; self.v.play().catch(function () {}); });
          this.addEventListener('mouseleave', function () { if (self.classList.contains('is-sound')) return; self.v.pause(); });
        }
        this.b.addEventListener('click', function () {
          document.querySelectorAll('abera-ugc.is-sound').forEach(function (o) { if (o !== self) { o.classList.remove('is-sound'); o.v.pause(); o.v.muted = true; o.v.controls = false; } });
          self.load(); self.classList.add('is-sound'); self.v.muted = false; self.v.controls = true; self.v.currentTime = 0; self.v.play().catch(function () {});
        });
      }
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ab-ugc__arrow');
    if (!a) return;
    var row = a.closest('.ab-ugc').querySelector('.ab-ugc__row');
    row.scrollBy({ left: parseInt(a.dataset.dir, 10) * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
  });


  /* Accessibility: give icon-only controls from the base theme a readable name. */
  function initA11y() {
    var named = function (el) { return el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || (el.textContent || '').trim() || el.querySelector('img[alt]:not([alt=""])'); };
    var set = function (sel, label) { document.querySelectorAll(sel).forEach(function (el) { if (!named(el)) el.setAttribute('aria-label', label); }); };
    set('.hdt-push-menu-btn', 'Open menu');
    set('a[href$="/search"]', 'Search');
    set('button[name="previous"]', 'Previous image');
    set('button[name="next"]', 'Next image');
    document.querySelectorAll('input.hdt-quantity__input').forEach(function (el) {
      var lb = el.id && document.querySelector('label[for="' + el.id + '"]');
      if (!el.getAttribute('aria-label') && !(lb && lb.getClientRects().length)) el.setAttribute('aria-label', 'Quantity');
    });
  }

  function boot() { initReveal(); initBanner(); initA11y(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();